<template>
  <div
    class="intro"
    :class="{ 'intro_inverted': invertTextColor }"
    :style="`background-image: ${isDesktop && imageAsBackground ? 'url(' + image + ')' : 'none'};`"
  >
    <div class="intro__image" :class="{'intro__image_with-padding': imagePadding}" >
      <div v-if="isDesktop && !imageAsBackground" class="image" :style="`background-image: url('${image}');`"></div>
      <div v-if="!isDesktop" class="image">
        <img :src="image"/>
      </div>
    </div>
    <div class="intro__main">
      <div class="main__title-above" v-if="titleAbove" v-html="titleAbove"></div>
      <div class="main__title" v-html="title"></div>
      <div class="main__subtitle" v-if="subtitle" v-html="subtitle"></div>
      <div v-if="buttonAction" class="main__button">
        <Button
          variant="primary"
          size="lg"
          @click="onAction"
          mobile
        >
          {{ buttonText }}
        </Button>
      </div>
      <div v-if="note && buttonAction" class="main__note" v-html="note"></div>
    </div>
  </div>
</template>

<script>
import Button from '@rr-component-library/button/src/main';

export default {
  name: 'Intro',
  designVersion: '1.0.0',
  components: {
    Button,
  },
  props: {
    /**
     * Ссылка на изображение
     */
    image: {
      type: String,
    },
    /**
     * Изображение с отступами сверху-снизу, или без отступов (cover)
     */
    imagePadding: {
      type: Boolean,
      default: false,
    },
    /**
     * Использовать изображение в качестве фона всей секции на desktop
     */
    imageAsBackground: {
      type: Boolean,
      default: false,
    },
    /**
     * Текст приписки над заголовком
     */
    titleAbove: {
      type: String,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Текст подзаголовка
     */
    subtitle: {
      type: String,
    },
    /**
     * Текст на кнопке
     */
    buttonText: {
      type: String,
    },
    /**
     * Ссылка / действие по нажатию на кнопку
     */
    buttonAction: {
      type: Object,
    },
    /**
     * Текст заметки под кнопкой
     */
    note: {
      type: String,
    },
    /**
     * Выводить надписи белым цветом вместо neutral black
     */
    invertTextColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDesktop: false,
    };
  },
  methods: {
    onAction() {
      if (!this.buttonAction) return;
      if (this.buttonAction.link) location.href = this.buttonAction.link;
      else if (this.buttonAction.action) this.buttonAction.action();
    },
    onResize() {
      this.isDesktop = window.innerWidth >= 1200;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Intro";
</style>
